import { forwardRef, Fragment } from 'react';
import { Flex } from '../../Flex/index.js';
import { Card } from '../Card/index.js';
import { CardMediaGrid, StyledFooter } from './styles.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import { Spacer } from '../../primitives/Spacer/index.js';

const NONE = 'none';
const CardMedia = forwardRef(function ForwardedCardMedia({
  children,
  columnWidths = 'equal',
  footer,
  hasContentPadding,
  header,
  media,
  mediaPlacement = 'top',
  padding = 'md',
  variant,
  footerVariant = 'default',
  ...props
}, ref) {
  const hasTwoColumns = mediaPlacement !== 'top';
  const spacerMap = {
    none: null,
    sm: '2',
    md: '3'
  };
  const AUTO = 'auto';
  const spacerValue = spacerMap[padding];
  const contentSpacerValue = hasContentPadding && padding !== 'none' ? spacerValue : null;
  const contents = () => {
    if (mediaPlacement === 'top') return jsxs("div", {
      children: [jsx("div", {
        children: media
      }), jsx(Spacer, {
        as: "header",
        pl: spacerValue,
        pr: spacerValue,
        children: jsx("div", {
          children: header
        })
      }), jsx(Spacer, {
        pl: contentSpacerValue,
        pr: contentSpacerValue,
        children: children
      }), jsx(StyledFooter, {
        as: "footer",
        footerVariant: footerVariant,
        pb: spacerValue,
        pl: spacerValue,
        pr: spacerValue,
        children: jsx("div", {
          children: footer
        })
      })]
    });
    return jsxs(Fragment, {
      children: [mediaPlacement === 'left' && jsx("div", {
        children: media
      }), jsxs(Flex, {
        flexDirection: "column",
        children: [jsx(Spacer, {
          as: "header",
          pl: spacerValue,
          pr: spacerValue,
          pt: spacerValue,
          children: header
        }), jsx(Spacer, {
          mb: AUTO,
          pl: contentSpacerValue,
          pr: contentSpacerValue,
          children: children
        }), jsx(StyledFooter, {
          as: "footer",
          footerVariant: footerVariant,
          pb: spacerValue,
          pl: spacerValue,
          pr: spacerValue,
          children: footer
        })]
      }), mediaPlacement === 'right' && jsx("div", {
        children: media
      })]
    });
  };
  return jsx(Card, {
    ref: ref,
    variant: variant,
    ...props,
    padding: NONE,
    children: jsx(CardMediaGrid, {
      columnWidths: columnWidths,
      hasTwoColumns: hasTwoColumns,
      padding: padding,
      children: contents()
    })
  });
});

export { CardMedia };
